import { API_URL } from '../api';

const authFetch = async (url, options = {}) => {
  const target  = url.startsWith('/') ? `${API_URL}${url}` : url;
  const token   = localStorage.getItem('auth_token');
  const headers = new Headers(options.headers || {});
  if (token) headers.set('Authorization', `Bearer ${token}`);
  const res = await fetch(target, { ...options, headers });
  if (res.status === 401) {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    window.location.href = '/login';
  }
  return res;
};

/** The server's message ({ error }) of a failed response, or the fallback. */
export const responseError = async (res, fallback) => {
  const body = await res.json().catch(() => ({}));
  return body.error || fallback;
};

export default authFetch;
